import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import MainPage from './pages/MainPage';
import JobsPage from './pages/jobs/JobsPage';
import PipelinesPage from './pages/pipelines/PipelinesPage';
import PipelineEditorPage from './pages/pipelines/PipelineEditorPage';
import SparkPage from './pages/spark/SparkPage';
import CustomContainersPage from './pages/custom-containers/CustomContainersPage';
import PipelineDetailsPage from './pages/pipelines/PipelineDetailsPage';
import PipelineVersionsPage from './pages/pipelines/PipelineVersionsPage';
import JobDetailsPage from './pages/jobs/JobDetailsPage';
import ChainsPage from './pages/chains/ChainsPage';
import ChainEditorPage from './pages/chains/ChainEditorPage';
import ChainDetailsPage from './pages/chains/ChainDetailsPage';
import ChainEditPage from './pages/chains/ChainEditPage';
import ArtifactsPage from './pages/artifacts/ArtifactsPage';
import FilesPage from './pages/files/FilesPage';
import ReportBuilderPage from './pages/reports/builder/report-builder';
import ReportsDirectoryPage from './pages/reports/ReportsDirectory';
import InsightsManager from './pages/insights/InsightsManager';
import LoginPage from './pages/auth/LoginPage';
import UsersPage from './pages/auth/UsersPage';
import UserEditPage from './pages/auth/UserEditPage';
import RolesPage from './pages/auth/RolesPage';
import RoleDetailsPage from './pages/auth/RoleDetailsPage';
import SSOProvidersPage from './pages/auth/SSOProvidersPage';
import SSOProviderDetailsPage from './pages/auth/SSOProviderDetailsPage';
import AddSSOProviderPage from './pages/auth/AddSSOProviderPage';
import UserProfilePage from './pages/auth/UserProfilePage';
import APIKeysPage from './pages/auth/APIKeysPage';
import AuditLogsPage from './pages/auth/AuditLogsPage';
import BreakGlassIncidentsPage from './pages/auth/BreakGlassIncidentsPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import { AuthProvider } from './utils/auth/AuthContext';
import { useTheme } from './ThemeContext';

function App() {
  const { theme } = useTheme();
  
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public route - Login */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Protected routes */}
          <Route path="/*" element={
            <ProtectedRoute>
              <div style={{ minHeight: '100vh', display: 'flex', background: theme.background }}>
                <div style={{ position: 'fixed', top: 0, left: 0, width: 240, height: '100vh', borderRight: `1px solid ${theme.border}`, background: theme.navbarBackground, overflow: 'hidden' }}>
                  <Navbar />
                </div>
                <main style={{ marginLeft: 240, flex: 1, padding: 24 }}>
                  <Routes>
                    <Route path="/" element={<MainPage />} />
                    <Route path="/jobs" element={<JobsPage />} />
                    <Route path="/jobs/:id" element={<JobDetailsPage />} />
                    <Route path="/pipelines" element={<PipelinesPage />} />
                    <Route path="/pipelines/new" element={<PipelineEditorPage />} />
                    <Route path="/pipelines/:id" element={<PipelineDetailsPage />} />
                    <Route path="/pipelines/:id/edit" element={<PipelineEditorPage />} />
                    <Route path="/pipelines/:id/versions" element={<PipelineVersionsPage />} />
                    <Route path="/chains" element={<ChainsPage />} />
                    <Route path="/chains/new" element={<ChainEditorPage />} />
                    <Route path="/chains/:id" element={<ChainDetailsPage />} />
                    <Route path="/chains/:id/edit" element={<ChainEditPage />} />
                    <Route path="/spark" element={<SparkPage />} />
                    <Route path="/custom-containers" element={<CustomContainersPage />} />
                    <Route path="/artifacts" element={<ArtifactsPage />} />
                    <Route path="/reports" element={<ReportsDirectoryPage />} />
                    <Route path="/reports/builder" element={<ReportBuilderPage />} />
                    <Route path="/report-builder" element={<ReportBuilderPage />} />
                    <Route path="/insights" element={<InsightsManager />} />
                    <Route path="/files" element={<FilesPage />} />
                    <Route path="/profile" element={<UserProfilePage />} />
                    <Route path="/auth/users" element={<UsersPage />} />
                    <Route path="/auth/users/:id/edit" element={<UserEditPage />} />
                    <Route path="/auth/roles" element={<RolesPage />} />
                    <Route path="/auth/roles/:id" element={<RoleDetailsPage />} />
                    <Route path="/auth/sso-providers" element={<SSOProvidersPage />} />
                    <Route path="/auth/sso-providers/add" element={<AddSSOProviderPage />} />
                    <Route path="/auth/sso-providers/:id" element={<SSOProviderDetailsPage />} />
                    <Route path="/auth/api-keys" element={<APIKeysPage />} />
                    <Route path="/auth/audit-logs" element={<AuditLogsPage />} />
                    <Route path="/auth/break-glass-incidents" element={<BreakGlassIncidentsPage />} />
                  </Routes>
                </main>
              </div>
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
